import * as firebase from 'firebase'

const config = require('../secrets/firebase-config.json')

if (!firebase.apps.length) {
    firebase.initializeApp(config)
}

const db = firebase.database()
const auth = firebase.auth()

export {
    db,
    auth
}



// WEBPACK FOOTER //
// ./src/firebase/firebase.js